// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationNotes-cls1_xXe","cls2":"TranslationNotes-cls2_6Ok TranslationNotes-cls1_xXe"};